import type React from 'react';
import styles from './BusinessFlow.module.css';

interface RequestDetailModalProps {
  request: any;
  onClose: () => void;
}

export const RequestDetailModal: React.FC<RequestDetailModalProps> = ({ request, onClose }) => {
  return (
    <div className={styles.modal} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <div className={styles.modalHeaderInner}>
            <span className={styles.requestOrder}>{request.order}</span>
            <span className={styles.methodBadge} data-method={request.request?.method?.toUpperCase() || 'GET'}>
              {request.request?.method || 'GET'}
            </span>
            <h2 className={styles.modalTitle}>{request.name}</h2>
          </div>
          <button className={styles.closeButton} onClick={onClose}>
            ×
          </button>
        </div>

        <div className={styles.modalSection}>
          <h3 className={styles.modalSectionTitle}>URL</h3>
          <pre className={styles.codeBlock}>
            {typeof request.request?.url === 'string' ? request.request.url : request.request?.url?.raw || 'N/A'}
          </pre>
        </div>

        {request.request?.header && request.request.header.length > 0 && (
          <div className={styles.modalSection}>
            <h3 className={styles.modalSectionTitle}>Headers</h3>
            <div className={styles.keyValueList}>
              {request.request.header.map((header: any, idx: number) => (
                <div className={styles.keyValueItem} key={idx}>
                  <span className={styles.keyValueKey}>{header.key}:</span>
                  <span className={styles.keyValueValue}>{header.value || '(empty)'}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {request.request?.body && (
          <div className={styles.modalSection}>
            <h3 className={styles.modalSectionTitle}>Request Body</h3>
            <pre className={styles.codeBlock}>
              {request.request.body.mode === 'raw'
                ? request.request.body.raw || '(empty)'
                : request.request.body.mode === 'formdata'
                  ? JSON.stringify(request.request.body.formdata, null, 2)
                  : request.request.body.mode === 'urlencoded'
                    ? JSON.stringify(request.request.body.urlencoded, null, 2)
                    : `Body mode: ${request.request.body.mode}`}
            </pre>
          </div>
        )}

        {request.event && request.event.length > 0 && (
          <>
            {request.event.find((e: any) => e.listen === 'prerequest') && (
              <div className={styles.modalSection}>
                <h3 className={styles.modalSectionTitle}>Pre-request Script</h3>
                <pre className={styles.codeBlock}>
                  {request.event.find((e: any) => e.listen === 'prerequest')?.script?.exec?.join('\n') || '(empty)'}
                </pre>
              </div>
            )}

            {request.event.find((e: any) => e.listen === 'test') && (
              <div className={styles.modalSection}>
                <h3 className={styles.modalSectionTitle}>Tests</h3>
                <pre className={styles.codeBlock}>
                  {request.event.find((e: any) => e.listen === 'test')?.script?.exec?.join('\n') || '(empty)'}
                </pre>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
